export const CHAT_MESSAGE_TYPE = {
    COMMON: "COMMON",
    READ : "READ"
};
